import Button from '../../../components/base/Button';

export default function InstagramSection() {
  const instagramPosts = [
    {
      id: 1,
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/ce61585bcfe2bf43ff66148c1ae75bb8.png',
      caption: '7 Vantagens Dos Refrescos De 10 Litros TecNutri!'
    },
    {
      id: 2,
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/3f90e25d47623c656a179b34c7e90705.png',
      caption: 'Aumente a satisfação dos seus clientes com nossa gelatina zero açúcares!'
    },
    {
      id: 3,
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/32c3322da03fd2b2a187fab2c3c5cf8a.png',
      caption: 'Mistura Para Tempurá TecNutri! O ingrediente que faltava no seu menu!'
    },
    {
      id: 4,
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/450f32df92a3cd4e1770321ede9bc7b7.png',
      caption: 'Farinha Para Empanar Panko TecNutri o produto que faltava no seu menu!'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-red-600 font-semibold text-lg">Conheça mais sobre a TecNutri</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-2 mb-4 flex items-center justify-center gap-4">
            Nosso Instagram
            <i className="ri-instagram-fill text-pink-500"></i>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Acompanhe nossas novidades, receitas e dicas no Instagram
          </p>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {instagramPosts.map((post) => (
            <a 
              key={post.id} 
              href="https://www.instagram.com/tecnutrifoodservice/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group cursor-pointer"
            >
              <div className="aspect-square overflow-hidden rounded-xl bg-gray-100 relative">
                <img
                  src={post.image}
                  alt={post.caption}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <i className="ri-instagram-line text-white text-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            Siga nosso Instagram
          </h3>
          <Button 
            size="lg" 
            className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white"
            onClick={() => window.open('https://www.instagram.com/tecnutrifoodservice/', '_blank')}
          >
            <i className="ri-instagram-fill mr-2"></i>
            @tecnutrifoodservice
          </Button>
        </div>
      </div>
    </section>
  );
}